"use client";

import * as React from 'react';
import { Switch as BaseSwitch } from '@base-ui/react/switch';
import { cn } from '@/lib/utils/cn';

const Switch = React.forwardRef<
  HTMLButtonElement,
  Omit<React.ComponentPropsWithoutRef<typeof BaseSwitch.Root>, 'className'> & { className?: string }
>(({ className, ...props }, ref) => (
  <BaseSwitch.Root
    ref={ref}
    className={(state) =>
      cn(
        'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zen-ring disabled:cursor-not-allowed disabled:opacity-50',
        state.checked ? 'bg-zen-primary' : 'bg-zen-input',
        className,
      )
    }
    {...props}
  >
    <BaseSwitch.Thumb
      className={(state) =>
        cn(
          'pointer-events-none block h-4 w-4 rounded-full bg-zen-surface shadow transition-transform',
          state.checked ? 'translate-x-4' : 'translate-x-0',
        )
      }
    />
  </BaseSwitch.Root>
));
Switch.displayName = 'Switch';

export { Switch };
